import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { Link } from '@inertiajs/react';
import { getAppThemeName } from '../../../services/appTheme';
// eslint-disable-next-line unused-imports/no-unused-vars
const StyledMenuItem = styled(({ isActive, asType: as, ...props }) => (_jsx(Link, { ...props, as: as }))) `
    transition: margin-left 0.2s ease-in-out;
    position: relative;
    display: flex;
    align-items: center;
    padding: 15px 25px;
    text-decoration: none;
    cursor: pointer;
    border: 0;
    background-color: transparent;

    &:after {
        content: '';
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 0;
        width: 3px;
        height: 38px;
        background-color: ${props => props.theme.secondary};
        transition: all 0ms ease-in-out;
        opacity: ${props => (props.isActive ? '1' : '0')};
        border-radius: 2px;

        @media only screen and (min-width: 992px) {
            right: -12px;
        }
    }

    ${props => !props.isActive &&
    css `
            &:hover,
            &:focus {
                margin-left: 8px;

                h4 {
                    color: ${props => props.theme.secondary};
                }

                svg {
                    fill: ${props => props.theme.secondary};
                }
            }
        `}
`;
const Icon = styled.span `
    display: flex;
    align-items: center;
    justify-content: center;
    transition: fill 0.2s ease-in-out;
    min-width: 30px;
    width: 30px;
    margin-right: 6px;
    text-align: center;

    svg {
        transition: fill 0.2s ease-in-out;
        fill: ${getAppThemeName() === 'invoned'
    ? props => props.isActive
        ? props => props.theme.tertiary
        : props => props.theme.primary.base
    : props => props.isActive
        ? props => props.theme.secondary
        : props => props.theme.primary.base};
    }
`;
const Title = styled.span `
    transition: color 0.2s ease-in-out;
    font-size: 16px;
    line-height: 14px;
    font-weight: ${props => (props.isActive ? '700' : '400')};
    color: ${props => props.theme.primary.base};
    white-space: nowrap;
`;
const MenuItem = ({ icon, children, isActive, as, ...rest }) => (_jsxs(StyledMenuItem, { isActive: isActive, ...rest, asType: as, children: [_jsx(Icon, { isActive: isActive, children: icon }), _jsx(Title, { isActive: isActive, children: children })] }));
export default MenuItem;
